<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "FIRMWARE_UPDATE_DETAILS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>

  <div class="row g-0 m-0 body mt-3 mb-3">
    @if (!firmwareStatus) {
      <div class="initialization-container">
        <div class="initialization-text">{{ "FIRMWARE_UPDATE_STARTED" | translate }}</div>
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    }

    @if (firmwareStatus) {
      <div class="steps-container p-3">
        <div class="mb-2">
          <span class="item-name">{{ "DEVICESETUP_METERNO" | translate }}: </span>
          <span class="item-info">{{ firmwareStatus.meterNo }}</span>
        </div>
        @if (targetModelName) {
          <div class="mb-2">
            <span class="item-name">{{ "FIRMWARE_UPDATE_TARGET_MODEL" | translate }}: </span>
            <span class="item-info">{{ targetModelName }}</span>
          </div>
        }
        <div class="mb-2">
          <span class="item-name">{{ "STATUS" | translate }}: </span>
          <span class="item-info" [ngClass]="{
            'step-success': firmwareStatus.status === CommandStatus.Success,
            'step-failed': isFailed
          }">{{ firmwareStatus.status === CommandStatus.ErrorOccured ? ('FATAL_ERROR' | translate) : firmwareStatus.status }}
          </span>
          @if (isFailed && firmwareStatus.error?.message) {
            <div class="error-msg mt-2">{{ firmwareStatus.error!.message }}</div>
          }
        </div>

        @if (firmwareStatus.maxRetryCount > 0) {
          <div class="mb-2">
            <span class="item-name">{{ "ATTEMPT" | translate }}: </span>
            <span class="item-info">{{ firmwareStatus.retryCount }} / {{ firmwareStatus.maxRetryCount }}</span>
          </div>
        }
        @if (firmwareStatus.steps && firmwareStatus.steps.length > 0) {
          <div class="mb-2"><span class="item-name">{{ "STEPS" | translate }}: </span></div>
          <ol class="steps-list mt-2">
            @for (step of firmwareStatus.steps; track $index) {
              <li class="step-item">{{ step }}</li>
            }
          </ol>
        }

      </div>
    }
  </div>

  <div class="row g-0 m-0 p-3 align-items-center bordert footer-row">
    @if (firmwareStatus) {
      <div class="col-md-12 mb-3">
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width.%]="percentCompleted"
               [attr.aria-valuenow]="percentCompleted" aria-valuemin="0" aria-valuemax="100">
            {{ percentCompleted }}%
          </div>
        </div>
      </div>
    }

    @if (authService.isAuthorized([PermissionsEnum.Device_firmware_update])) {
      @if (isFailed) {
        <div class="d-flex justify-content-end gap-2 ms-auto">
          <div class="p-2 d-flex align-items-center edit rounded cursor-pointer" (click)="retryFirmwareUpdate()">
            <span class="item-name pe-2">{{ "RETRY" | translate }}</span>
            <img alt="Retry" src="assets/device/firmware-update.svg" />
          </div>
          <div class="p-2 d-flex align-items-center edit rounded cursor-pointer" (click)="isCancelModalOpen = true">
            <span class="item-name pe-2">{{ "ABORT" | translate }}</span>
            <svg-icon alt="Abort" src="assets/device/firmware-update-abort.svg"></svg-icon>
          </div>
        </div>
      }

      @if (isInProgress) {
        <div class="col-md-3 p-2 d-flex justify-content-end edit rounded ms-auto cursor-pointer"
             (click)="isCancelModalOpen = true">
          <span class="item-name pe-2">{{ "ABORT" | translate }}</span>
          <svg-icon alt="Abort" src="assets/device/firmware-update-abort.svg"></svg-icon>
        </div>
      }
    }
  </div>

  <!-- Cancel/abort confirmation modal -->
  @if (isCancelModalOpen) {
  <app-confirm-dialog titleKey="ABORT" question="DEVICE_FWUPDATEABORT"
    (confirm)="abortFirmwareUpdate()" (cancel)="isCancelModalOpen = false"></app-confirm-dialog>
  }
</div>
